export const BALANCES = {
  CURRENT: 'currentBalance',
  NEXT: 'nextBalance'
};
